import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock,FaHistory, FaBook, FaEye } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MdSchool, MdPeople, MdPerson } from "react-icons/md";
import Return from "./Return";
import Return_Table from "./Return_Table";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

const Return_main = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleButtonClick = () => {
    navigate("/staff/library_return_book_list"); // Redirect to the specified path
  };
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Return Book</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Flex gap={2}>
                {/* <Fine_Modal /> */}
                <div>
                  <Button
                    onClick={handleButtonClick}
                    colorScheme="purple" // Chakra UI provides color schemes like 'blue'
                    leftIcon={<FaHistory />}
                    borderRadius="md" // Use Chakra UI's borderRadius prop for rounded corners
                  >
                    Return History
                  </Button>
                </div>{" "}
              </Flex>
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Library </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Return Book</span>
          </Link>
        </Box>
      </div>

      <Box p={6} flex="2" mb={9}>
        <Return />
      </Box>
    </Box>
  );
};

export default Return_main;
